module.exports = __webpack_public_path__ + "img/128.1.913497ea.jpg";